/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


export default
{
  Building: 0,
  Unit: 1,
};
